import { cn } from '@/lib/utils';
import { useBrandTheme, BRAND_LOGO_SRC } from '@/hooks/use-brand-theme';

interface BrandMarkProps {
  /** Render the "CompBox" wordmark next to the logo. Defaults to true. */
  withWordmark?: boolean;
  /**
   * Extra classes for the wrapping element — layout only (spacing,
   * positioning). Logo and wordmark sizing is fixed to the canonical
   * login-page dimensions and must not be overridden.
   */
  className?: string;
}

/**
 * Canonical CompBox brand lockup.
 *
 * Encodes the login-page reference dimensions as the single source of
 * truth: logo `h-9`, wordmark `text-lg font-semibold tracking-tight`.
 * Use this everywhere the brand appears instead of hand-rolling
 * logo + wordmark markup.
 */
export function BrandMark({ withWordmark = true, className }: BrandMarkProps) {
  const { brand } = useBrandTheme();

  return (
    <div className={cn('flex items-center gap-2.5', className)}>
      <img src={BRAND_LOGO_SRC[brand]} alt="CompBox" className="h-9 shrink-0" />
      {withWordmark && (
        <span className="text-foreground text-lg font-semibold tracking-tight">
          CompBox
        </span>
      )}
    </div>
  );
}
